<template>
  <button :disabled="disabled" class="btn btn_square pfbtn">
    <span class="btn__overlay"></span>
    <span class="btn__text">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: {type: Boolean, default: false},
    nodecor: {type: Boolean, default: false},
    toright: {type: Boolean, default: false}
  }
}
</script>

<style lang="sass">
.pfbtn
  width: fit-content
  display: flex
  align-items: center
  justify-content: center
  height: 54px
  width: 220px
  max-width: 100%
  font-weight: 500
  font-family: globalvars.$font6
  font-size: 16px
  position: relative
  z-index: 1
  white-space: nowrap
  cursor: pointer
  padding: 0 32px
  background: none
  @include for-mob
    width: 150px
  @include from(400px)
    width: 140px
    height: 50px
  @include from(350px)
    width: 120px
    font-size: 14px
    height: 45px
  &_gray
    border-color: colors.$silver
  &_right
    margin-left: auto
  svg
    margin-left: -14px
    margin-right: 30px
  overflow: hidden
  &[disabled]
    pointer-events: none
    opacity: .4
    color: colors.$brownfont
  

</style>